<form [formGroup]="formularioBase" class="container-fluid px-0">
  <div *ngIf="formularioCargado" class="row g-3">
    <ng-container *ngFor="let control of datosFormulario">
      <div *ngIf="control.name" [class]="control.cols">
        <div class="form-group mb-2">
          
          <label *ngIf="control.label" [for]="control.id" class="form-label fw-bold mb-1" style="color: #333; font-size: 16px;">
            {{ control.label }} <span *ngIf="control.field.required">*</span>
          </label>

          <div [ngSwitch]="control.field.type">
            <div *ngSwitchCase="'select'">
              <jsonform-form-control-select
                [jsonControl]="control"
                [control]="$any(control.formControl)"
                [opciones]="
                  (control.field.custom_option
                    ? opcionesPersonalizadas[$any(control.field.custom_option)]
                    : control.field.options) || []
                "
              ></jsonform-form-control-select>
            </div>
            <div *ngSwitchDefault>
              <jsonform-form-control-input
                [jsonControl]="control"
                [control]="$any(control.formControl)"
              ></jsonform-form-control-input>
            </div>
          </div>

          <small *ngIf="control.field.helptext" [id]="'helpId-' + control.id" class="form-text text-muted mt-1">
            {{ control.field.helptext }}
          </small>
        </div>
      </div>
    </ng-container>
  </div>
</form>